import graphql from 'babel-plugin-relay/macro';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { usePreloadedQuery, useQueryLoader } from 'react-relay';
import Component from '../Terminals/Terminals';

export const TerminalsQuery = graphql`
    query TerminalsQuery($periods: [Int!], $hasActiveStorageConditions: Boolean) {
        terminals(periods: $periods, hasActiveStorageConditions: $hasActiveStorageConditions) {
            id
            name
            hafasId
            country {
                name
            }
            info {
                latitude
                longitude
                address
                country
                zip
                city
                openingHoursText
                additionalText
                openingHours {
                    text
                    from
                    until
                }
            }
            agency {
                title
                email
                phone
                address
                city
                zip
                openingHoursText
                notes
                openingHours {
                    text
                    from
                    until
                }
            }
            primaryBookingOffice {
                phoneCountryCode
                phoneAreaCode
                title
                email
                phone
                notes
                openingHoursText
                openingHours {
                    text
                    from
                    until
                }
            }
            secondaryBookingOffice {
                phoneCountryCode
                phoneAreaCode
                title
                email
                phone
                notes
                openingHoursText
                openingHours {
                    text
                    from
                    until
                }
            }
            facilityInfo {
                dangerousGoodsAllowed
                dangerousGoodsText
                dangerousGoodsStorageAvailable
                parkingPossible
                parkingText
                repairService
                cleaning
                reeferPlugsAvailable
                customsOnSite
                customsText
                notes
            }
        }
    }
`;

const Terminals = (props) => {
    const { terminals } = usePreloadedQuery(TerminalsQuery, props.preloadedQuery);
    return <Component terminals={terminals} visibleInfo={props.visibleInfo} />;
};

Terminals.propTypes = {
    preloadedQuery: PropTypes.object,
};

export default Terminals;

export const TerminalsBy = (props) => {
    const [preloadedQuery, loadTerminalsQuery] = useQueryLoader(TerminalsQuery);

    useEffect(() => {
        loadTerminalsQuery({ periods: props.periods, hasActiveStorageConditions: true }, {});
    }, [loadTerminalsQuery, props.periods]);

    return preloadedQuery ? (
        <Terminals preloadedQuery={preloadedQuery} visibleInfo={props.visibleInfo} />
    ) : null;
};
